import React from 'react';
import PageLinks from '../atom/PageLinks';
import MovieButton from '../atom/MovieButton';
import ContactButton from '../atom/ContactButton';
import CompanyInfoText from '../atom/CompanyInfoText';
import Ralsnet from '../atom/Ralsnet';
import styles from './Menu.module.scss';

type Props = {
  isOpen: boolean;
  close: () => void;
};

const Menu: React.FC<Props> = ({ isOpen, close }) => {
  if (isOpen) {
    document.body.classList.add('menuOpened');
  } else {
    document.body.classList.remove('menuOpened');
  }

  return (
    <div className={styles.menu} style={{ display: isOpen ? 'block' : 'none' }}>
      <PageLinks setPosition='menu' onClick={close} />
      <div className={styles.menu__contact}>
        <MovieButton />
        <ContactButton />
        <CompanyInfoText />
      </div>
      <Ralsnet />
    </div>
  );
};

export default Menu;
